import React from 'react';
import voca from 'voca';
import { convertTimeStampToDate } from '../../common/utils/dateUtils';
import { Link } from 'react-router-dom';
import TooltipInfo from '../../common/docs/TooltipInfo';
import {
  SUPABASE,
  XANO,
  XATA,
  SALESFORCE,
  APP_WRITE,
  DIRECTUS,
  AIRTABLE,
  MYSQL,
} from 'drapcode-constant';
import { description } from '../../common/utils/event_constants';
import { collectionTypeBadge as inUseTypeBadge } from '../../common/utils/validate';
const DATA_SOURCE_TYPES = [SUPABASE, XANO, SALESFORCE, APP_WRITE, XATA, DIRECTUS, AIRTABLE, MYSQL];
const ExternalApiTable = ({
  projectId,
  version,
  collections,
  externalapi,
  deleteExternalApiPending,
  handleDelete,
  handleClone,
  flag,
}) => {
  const methodTypeBadge = () => {
    const { setting } = externalapi;
    const { methodType } = setting;
    let badge = 'badge-primary';
    switch (methodType) {
      case 'DELETE':
        badge = 'badge-theme-danger';
        break;
      case 'GET':
        badge = 'badge-info';
        break;
      case 'POST':
        badge = 'badge-success';
        break;
      case 'PUT':
        badge = 'badge-warning';
        break;
      default:
        badge = 'badge-primary';
        break;
    }
    return (
      <>
        <span className={`badge ${badge}`} style={{ fontWeight: 'bold' }}>
          {`${methodType}`}
        </span>
      </>
    );
  };

  const processResponseBadge = () => {
    const { donotPersistResponseData, responseDataMapping } = externalapi;
    const { processResponse, enableAuthorization } = responseDataMapping ? responseDataMapping : '';
    const badgeType = processResponse
      ? donotPersistResponseData
        ? 'DONT_PERSIST'
        : enableAuthorization
        ? 'ENABLE_LOGIN_SIGNUP'
        : 'PERSIST'
      : 'DEFAULT';

    let badgeClass = '';
    let badgeTitle = '';
    let badgeText = '';

    switch (badgeType) {
      case 'DONT_PERSIST':
        badgeClass = 'badge-primary';
        badgeTitle = "Don't Persist: It will not save record in collection data";
        badgeText = "Don't Persist";
        break;
      case 'PERSIST':
        badgeClass = 'badge-success';
        badgeTitle =
          'Persist: You can update collection and also save record in current logged in user';
        badgeText = 'Persist';
        break;
      case 'ENABLE_LOGIN_SIGNUP':
        badgeClass = 'badge-warning';
        badgeTitle =
          'Enable Login/Signup: We will login and/or regiter the user with the response from API';
        badgeText = 'Enable Login/Signup';
        break;
      default:
        badgeClass = 'badge-info';
        badgeTitle = 'Default: Response data is not mapped with any collection';
        badgeText = 'Default';
        break;
    }

    if (badgeType) {
      return (
        <span
          className={`badge ${badgeClass}`}
          style={{ fontWeight: 'bold' }}
          title={`${badgeTitle}`}
        >
          {`${badgeText}`}
        </span>
      );
    } else {
      return '';
    }
  };

  const getCollectionTitle = (collectionName) => {
    const collection = collections.find((e) => e.collectionName === collectionName);
    return collection ? collection.collectionTitle : collectionName;
  };

  const generateEditUrl = () => {
    const { uuid, externalApiName, externalApiType } = externalapi;
    let editUrl = '';
    if (DATA_SOURCE_TYPES.includes(externalApiType)) {
      editUrl = `/2.0/externalapi/${version}/v/${projectId}/edit-external-source/${uuid}`;
    } else {
      editUrl = `/2.0/externalapi/${version}/v/${projectId}/edit/${uuid}`;
    }
    return (
      <Link to={editUrl} className="btn btn-xs btn-primary" title={`Edit ${externalApiName}`}>
        <i className="wb webconnect-pencil"></i>
      </Link>
    );
  };

  const collectionTypeBadge = (collectionName, type) => {
    let badge = 'badge-primary';
    switch (type) {
      case 'REQ':
        badge = 'badge-info';
        break;
      default:
        badge = 'badge-primary';
        break;
    }
    if (collectionName) {
      return (
        <TooltipInfo
          title={
            '<b>' +
            getCollectionTitle(collectionName) +
            `</b> is mapped with ${
              type && type === 'REQ' ? 'Request' : 'Response'
            } Data mapping section of External API.`
          }
          headerText={type && type === 'REQ' ? 'Request Collection' : 'Response Collection'}
          showHeader={true}
          showArrow={true}
        >
          <span
            className={`badge ${badge}`}
            style={{
              fontWeight: 'bold',
              textTransform: 'revert',
              display: 'block',
              width: 'fit-content',
            }}
          >
            {voca.truncate(getCollectionTitle(collectionName), 30)}
          </span>
        </TooltipInfo>
      );
    } else {
      return '';
    }
  };

  const {
    uuid,
    externalApiName,
    collectionName,
    responseDataMapping,
    createdAt,
    inUse = true,
  } = externalapi;

  return (
    <tr key={uuid} className="text-left td-align-middle">
      <td title={externalApiName}>{voca.truncate(externalApiName, 50)}</td>
      <td>{methodTypeBadge()}</td>
      <td>
        {collectionTypeBadge(collectionName, 'REQ')}
        {collectionName && responseDataMapping && responseDataMapping.selectedCollectionName && (
          <hr style={{ borderTop: '1px dashed #303453', margin: 0, visibility: 'hidden' }} />
        )}
        {responseDataMapping &&
          responseDataMapping.selectedCollectionName &&
          collectionTypeBadge(responseDataMapping.selectedCollectionName)}
      </td>
      <td>{processResponseBadge()}</td>
      <td>{convertTimeStampToDate(createdAt)}</td>
      <td>{inUseTypeBadge(inUse, 'inuse', 'external api')}</td>
      <td className="text-right">
        {generateEditUrl()}
        &nbsp;
        <button
          className="btn btn-xs btn-theme-submit"
          onClick={() => handleClone(externalapi)}
          title={`Clone ${externalApiName}`}
        >
          <i className="wb webconnect-clone"></i>
        </button>
        &nbsp;
        <button
          className="btn btn-xs btn-theme-delete"
          onClick={() => (flag ? handleDelete(uuid) : undefined)}
          disabled={deleteExternalApiPending}
          title={`Delete ${externalApiName}`}
          style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
        >
          <i className="wb webconnect-trash-solid"></i>
          {flag ? null : (
            <>
              &nbsp;
              <TooltipInfo
                title={description}
                headerText={`Permission Disabled!`}
                showHeader={true}
                showArrow={true}
              />
            </>
          )}
        </button>
      </td>
    </tr>
  );
};

export default ExternalApiTable;
